import {
  IListing,
  ICustomizations,
  IListingsAndConfig,
} from "./providers/types";
import { getCustomizations, getMainUrl } from "./providers/Customizations";
import { currencyToSymbol } from "./utils/price";

export function main(fn: () => any) {
  try {
    fn();

    if (process.env.OBSERVE_OFF) return

    const observer = new MutationObserver(() => fn());
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  } catch (e) {
    const err = e as Error
    console.info(err.message);
  }
}

export function observeNewElements(
  selector: string,
  fn: (element: Element, theme: ICustomizations, widgetId: string) => any
) {
  const elements = document.querySelectorAll(selector);
  for (var i in elements) {
    if (
      !elements[i] ||
      !elements[i].getAttribute ||
      elements[i].getAttribute("observed")
      ) {
        // return;
      } else {
      elements[i].setAttribute("observed", "yes");
      const theme = getCustomizations(window.location, elements[i]);
      fn(elements[i], theme, i);
      var element = elements[i];
      if (!theme.noResize && typeof (window as any)["ResizeObserver"] !== "undefined") {
        var widgetId = i
        new (window as any)["ResizeObserver"](function () {
          const theme = getCustomizations(window.location, element);
          fn(element, theme, widgetId);
        }).observe(element);
      }
    }
  }
}

export function times(n: number) {
  const a = [];
  for (let i = 0; i < n; i++) {
    a.push(i);
  }
  return a;
}

export type RemoteSession = { lotameId?: string, panoramaId?: string, userId?: string, widgetCacheVersionId?: string }
export async function createRemoteSession(session: RemoteSession) {
  const { lotameId, panoramaId, widgetCacheVersionId } = session

  if (!lotameId) return
  if (!panoramaId) return
  if (!widgetCacheVersionId) return

  const key = [lotameId, panoramaId, widgetCacheVersionId].join('_')
  const value = localStorage.getItem(key)

  if (value) {
    session.userId = value
    return value
  }

  const userId = await fetch("//api.sellwild.com/session/rpc", {
    method: "POST",
    body: JSON.stringify({
      method: "createRemoteSession",
      params: { trackingData: { lotameId, panoramaId }, widgetCacheVersionId },
      id: "0",
    }),
  })
  .then(v => v.json())
  .then(v => v && v.result && v.result.rs && v.result.rs.userId)
  
  if (userId) {
    session.userId = userId
    localStorage.setItem(key, userId)
  }

  return userId
}

export type ListingAction = { trackingData: { lotameId?: string, panoramaId?: string, userId?: string }, listingId: number, membershipType: string }
export function sendListingAction ({ trackingData, listingId, membershipType }: ListingAction) {
  return fetch("//api.sellwild.com/session/rpc", {
    method: "POST",
    body: JSON.stringify({
      method: "listingAction",
      params: { trackingData, listingId, membershipType: String(membershipType), actionType: '1' },
      id: "0",
    }),
  })
  .then(v => v.json())
}

const listingCache: {[uri:string]: Promise<IListingsAndConfig>} = {}

export function loadListingsSm(
  theme: ICustomizations
): Promise<IListingsAndConfig> {

  if (listingCache[theme.listings]) return listingCache[theme.listings]

  listingCache[theme.listings] = fetch(theme.listings)
    .then((res) => res.json())
    .then((res) => ({
      listings: res.result.rs,
      config: res.result.config,
      widgetCacheVersionId: res.result.widgetCacheVersionId || '0',
    }));

  return listingCache[theme.listings]
}

export function computeCols(width: number) {
  if (width > 1800) return 6;
  if (width > 1500) return 5;
  if (width > 1200) return 4;
  if (width > 900) return 3;
  if (width > 600) return 2;
  return 1;
}

export function generateLiteWidget(
  theme: ICustomizations,
  topbanner: string,
  grid: string,
  bottombanner: string,
  cols: number
) {
  const title = (theme as any)[`title${cols}`] || theme.title;
  const linkText = (theme as any)[`linkText${cols}`] || theme.linkText;
  const titleHtml = [
    title || linkText ? '<div class="sellwild-header">' : "",
    title
      ? '<div class="sellwild-main-title">' +
        decodeURIComponent(title) +
        "</div>"
      : "",
    "<div style='width: 14px;'></div>",
    linkText
      ? `<a class="sellwild-main-link" href="${getMainUrl(
          theme, '', 'widget-header'
        )}" target="_blank" rel="nofollow sponsored noopener">` +
        decodeURIComponent(linkText) +
        "</a>"
      : "",
    title || linkText ? "</div>" : "",
  ].join("");
  return [
    `<div class="sellwild-widget ${
      theme.overlayTitle ? "sellwild-widget-overlay" : ""
    }">`,
    theme.titleBottom ? "" : titleHtml,
    `${
      topbanner
        ? `<div class="sellwild-banner"><div class="sellwild-banner-ad">${topbanner}</div></div>`
        : ""
    }`,
    `<div class="sellwild-grid">${grid}</div>`,
    `${
      bottombanner
      ? `<div class="sellwild-banner"><div class="sellwild-banner-ad">${bottombanner}</div></div>`
      : ""
    }`,
    theme.titleBottom ? titleHtml : "",
    theme.watermark ? buildWatermark(theme, cols) : "",
    `</div>`,
    theme.fontUrl && theme.fontFamily
      ? `<link rel="preconnect" href="https://fonts.gstatic.com">
    <link href="${theme.fontUrl}" rel="stylesheet">`
      : "",
    `<style>${styles(theme)}</style>`,
  ].join("");
}

function buildWatermark (theme: ICustomizations, cols: number) {
  const cs = []
  for (let i = 0; i < cols; i++) {
    cs.push(i)
  }
  return [
    '<div class="sellwild-watermark">',
    cs.map((i) => i === cs.length - 1 ? [
    '<div>',
    `<a href=${getMainUrl(theme, 'post', 'watermark')} target="_blank" rel="nofollow sponsored noopener">`,
    '<svg viewBox="0 0 271 143" fill="none" xmlns="http://www.w3.org/2000/svg">',
    '<path d="M186.7 99.3C187 99.5 187.4 99.7 187.8 99.9C184.5 100.6 178.3 99.8 172 97.9C159.4 94.2 148.3 87.4 137.5 80.1C132.8 76.9 128 73.8 122.5 72.1C116.5 70.3 110.8 70.3 105 73.1C102 74.6 98.6 75.4 95.4 77C95.9 77 96.4 77.1 96.8 77C103.5 75.8 109.9 77 115.9 80.2C118.7 81.7 121.5 83.3 124.1 85.2C136.5 94.2 150 101.3 164.4 106.3C164.7 106.4 165 106.6 165.6 106.8C157.7 107.3 150.5 105.8 143.4 103.7C134 101 125.3 96.8 116.8 92.1C108.9 87.7 100.9 83.5 92 81.2C88.6 80.3 85.6 80.5 82.3 82C63.9 90.4 46.5 100.4 30.8 113.2C30.2 113.7 29.6 114.2 29.1 114.6C33.5 113.6 37.9 112.4 42.4 111.7C49.8 110.5 57 111.8 63.8 114.6C76.6 119.8 89.2 125.2 102 130.3C106.4 132.1 111.1 133.4 115.7 135.3C112.6 135.3 109.5 135.3 106.4 135.3C91 135.2 76.8 130.5 62.9 124.4C55.2 121 47.2 118.3 38.7 117.6C33.7 117.2 28.8 117.9 24 119.5C23.1 119.8 22.1 120.5 21.5 121.2C15.6 127.9 9.69999 134.5 3.89999 141.3C2.59999 142.8 1.7 143.2 0 141.8C0.7 140.8 1.30001 139.8 2.10001 138.8C8.20001 130.7 15.3 123.5 22.8 116.7C24.4 115.3 25.8 113.6 26.9 111.8C33.2 100.9 37.7 89.2 40.5 77C43.2 65.3 48 54.5 54.1 44.3C61.1 32.5 69.3 21.5 78.3 11.1C72 23 67.1 35.5 62.8 48.3C59.9 57 57.3 65.9 53.8 74.4C48.9 86.2 41.6 96.6 33.5 106.4C32.9 107.1 32.3 107.9 31.7 108.6C31.6 108.7 31.6 108.9 31.4 109.4C32.1 109 32.6 108.7 33.1 108.4C38.4 104.7 43.8 101 49.1 97.2C50.4 96.3 51.7 95.2 52.5 93.9C58.5 83.4 64.5 72.9 70.2 62.2C81.8 40.4 95.7 20.3 111.8 1.6C112 1.4 112 0.999998 112.6 1.1C105.5 16.5 98.6 31.9 91.4 47.3C86.3 58.1 81.1 68.9 73 77.9C69.7 81.6 66.1 85.2 62.8 89.1C65.6 87.7 68.3 86 71.2 84.8C75.1 83.2 78 80.7 80.3 77.3C85.2 70.2 90.5 63.2 94.8 55.8C102.9 42 113.5 30.3 124.9 19.4C131.3 13.3 138.1 7.6 144.7 1.8C145.3 1.2 146 0.8 147 0C133.2 19 119.8 37.7 106.2 56.2C99.9 64.7 92 71.7 83.5 77.9C82.8 78.4 82.1 79 81.5 79.7C107.4 68.4 134.4 61.1 163 56.7C149.9 59.9 137.4 63 125 66C125 66.2 125.1 66.4 125.1 66.6C127.8 67.4 130.6 67.9 133.1 69.2C139.1 72.2 145 75.5 150.9 78.7C162.7 85.7 174.7 92.5 186.7 99.3ZM10.9 127.6C18.9 117.3 24.1 105.6 28.1 93.4C34.9 72 43.4 51.2 53.7 31.2C55.2 28.3 56.8 25.3 58.4 22.4C58.2 22.3 58.1 22.1 57.9 22C57 23 56.2 24.1 55.3 25C43.3 37.8 32.7 51.7 25.6 67.9C21 78.5 19.3 89.9 16.7 101C14.4 111.1 13.2 121.6 7.10001 131.2C7.90001 130.7 8.09999 130.7 8.29999 130.5C9.09999 129.6 9.99999 128.6 10.9 127.6ZM56.7 101.8C50.1 103 43.9 105.2 38.2 108.8C39 108.8 39.8 108.6 40.5 108.4C56.9 103.9 72.4 105.3 87.4 113.8C92.5 116.7 98.1 119 103.6 120.9C114.7 124.8 126.4 125.1 138.3 126.2C123.9 119.5 110 112.5 95.7 106.5C83.4 101.2 70.2 99.4 56.7 101.8ZM145.2 51.6C140 55.4 134.3 58.6 128.8 62.1C128.8 62.2 128.8 62.3 128.8 62.4C132.1 61.4 135.4 60.5 138.7 59.5C149.8 55.8 160.5 51.5 169.7 44.1C178.8 36.6 188 29.2 197.1 21.7C202.6 17.2 208.1 12.7 213.6 8.2C212.6 8.2 211.8 8.4 211 8.8C204.9 11.7 198.7 14.4 192.8 17.5C182.3 22.9 172.2 28.9 163.4 36.9C157.7 42 151.6 46.9 145.2 51.6ZM108.2 94.1C92.8 85.4 77.4 86.3 62.1 94.2C64.9 94 67.6 93.6 70.4 93.6C81.8 93.6 92.3 97 102.6 101.4C112.1 105.5 121.6 109.5 131.3 113C137.4 115.2 144 115.7 150.8 114.7C150.3 114.4 150.1 114.2 149.9 114.1C135.6 108.5 121.7 101.7 108.2 94.1ZM238.9 93.7C227.2 87.9 216.1 81 206 72.6C196.7 65 186.3 59.6 174.1 58.9C170.7 58.7 167.2 59.3 163.8 59.5C163.9 59.6 163.9 59.7 164 59.9C167.4 61.2 171 62.1 174.2 63.9C179.3 66.8 184.4 69.8 188.8 73.6C199.7 82.9 212.2 88.6 225.9 92C230.5 93.1 235.2 93.9 239.8 94.9C239.5 94 239.2 93.8 238.9 93.7ZM176.7 73.8C170 69.1 162.9 64.9 154.8 63.1C149.7 61.9 144.5 61.8 139 63.4C141 64 142.6 64.4 144.2 65C154.3 68.5 163.1 74.4 171.4 81.1C178.1 86.5 185.2 91.3 193.3 94.4C203.2 98.2 216.6 100.3 224.1 99.2C211.2 96.7 199.7 91.5 189.5 83.4C185.3 80 181 76.8 176.7 73.8ZM104 68.2C104.1 68.1 104.2 68.1 104.4 68C117.1 61.2 129 53.2 139.2 42.9C153.7 28.4 169.8 16 187.3 5.4C187.6 5.2 187.8 5 188 4.8C187.9 4.6 187.8 4.4 187.7 4.2C180.1 7.8 172.4 11 165 14.8C153.3 20.7 142.4 28 133.2 37.5C123.3 47.6 113.7 57.9 104 68.2ZM185.6 52.6C188.4 53 190.6 53.5 192.9 53.6C204.8 54.1 216.8 54.4 228.7 54.8C238.2 55.1 247.8 55.5 257.3 56C261.7 56.2 266 56.9 270.4 57.3C256.8 45.8 209.5 43 185.6 52.6ZM186.7 48C199.3 43 211.9 37.6 224.6 32.7C231.3 30.1 238.3 28.2 245.1 26C215.6 29.6 187.6 37.3 163.2 54.3C170.9 53.4 178.9 51.1 186.7 48Z" fill="url(#paint0_radial)"/>',
    '<defs>',
    '<radialGradient id="paint0_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(135.294 71.6067) scale(108.04)">',
    '<stop stop-color="#C7DB4E"/>',
    '<stop offset="0.0233905" stop-color="#BCD74B"/>',
    '<stop offset="0.0848263" stop-color="#A3CE46"/>',
    '<stop offset="0.1477" stop-color="#90C842"/>',
    '<stop offset="0.2122" stop-color="#85C442"/>',
    '<stop offset="0.2809" stop-color="#81C341"/>',
    '<stop offset="0.6685" stop-color="#3EB54A"/>',
    '<stop offset="0.8876" stop-color="#05A64B"/>',
    '<stop offset="1" stop-color="#67BD45"/>',
    '</radialGradient>',
    '</defs>',
    '</svg>',
    '</a>',
    '</div>',
    ].join('') : '<div></div>').join(''),
    '<div class="sellwild-popover">',
    `<a href=${getMainUrl(theme, 'post', 'watermark-popover')} target="_blank" rel="nofollow sponsored noopener">`,
    decodeURIComponent(theme.watermarkTitle),
    '</a>',
    '</div>',
    '</div>',
  ].join('')
}

export function generateLiteListing(className = '') {
  return [
    `<a class="sellwild-listing${className ? ' ' + className : ''}" data-loading="true">`,
    `<div class="listing-img-container" style="position: relative;">`,
    `<div class="listing-price"></div>`,
    `</div>`,
    `<p class="listing-title"></p>`,
    `<div class="listing-overlay"></div>`,
    `</a>`,
  ].join(" ");
}

export function updateLiteListing(
  listingEl: Element,
  listing: IListing | undefined,
  href: string
) {
  var src =
    (listing && listing.photos && listing.photos[0] && listing.photos[0].url) ||
    "";
  var title = (listing && listing.title) || "";
  var url = (listing && listing.url) || href;
  if (title.length > 60) title = title.slice(0, 60) + "...";
  var currency = (listing && listing.currency) || "";
  var price =
    (listing &&
      listing.price &&
      Number(listing.price).toLocaleString(undefined, {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      })) ||
    "";
  const imgEl = document.createElement('img')
  imgEl.classList.add('listing-img');
  const imgContainer = listingEl.querySelector('.listing-img-container')
  const priceEl = listingEl.querySelector(`.listing-price`);
  const titleEl = listingEl.querySelector(`.listing-title`);
  if (listingEl) listingEl.setAttribute('target', '_blank');
  if (listingEl) listingEl.setAttribute("data-loading", "false");
  if (listing && listingEl) listingEl.setAttribute("data-id", listing.id);
  if (listingEl && url) listingEl.setAttribute("href", url);
  if (imgEl && src) imgEl.setAttribute("src", src);
  if (imgEl && title && title.trim()) imgEl.setAttribute("alt", title);
  if (imgEl && imgContainer && src) imgContainer.appendChild(imgEl)
  if (priceEl && price)
    priceEl.innerHTML = `${currencyToSymbol(currency)}${price}`;
  else if (priceEl) {
    priceEl.setAttribute("style", "display: none");
  }
  if (titleEl && title) titleEl.innerHTML = title;
}

export function styles(theme: ICustomizations) {
  return [
    "sellwild {display: block;}",
    `.sellwild-widget a,.sellwild-widget a:hover {text-decoration: none!important;color: inherit;}`,
    theme.fontFamily
      ? `.sellwild-widget {font-family: ${theme.fontFamily};}`
      : "",
    `.sellwild-widget {position: relative;width: 100%;display:block; font-size: ${theme.fontSize}px; }`,
    `.sellwild-header {margin-bottom: ${theme.marginBottom}px; position: relative;width: 100%;display:flex;flex-direction: row; justify-content: space-between; align-items: center; flex-wrap: wrap;}`,
    `.sellwild-main-title {white-space: nowrap;}`,
    `.sellwild-main-link {white-space: nowrap;}`,
    `.sellwild-widget a.sellwild-main-link { text-decoration: underline!important; }`,
    theme.titleColor
      ? `.sellwild-main-title { color: ${theme.titleColor} }`
      : "",
    theme.titleSize
      ? `.sellwild-main-title { font-size: ${theme.titleSize}px }`
      : "",
    theme.titleSize3
      ? `@media all and (max-width: 1200px) { .sellwild-main-title { font-size: ${theme.titleSize3}px } }`
      : "",
    theme.titleSize2
      ? `@media all and (max-width: 900px) { .sellwild-main-title { font-size: ${theme.titleSize2}px } }`
      : "",
    theme.titleSize1
      ? `@media all and (max-width: 600px) { .sellwild-main-title { font-size: ${theme.titleSize1}px } }`
      : "",
    theme.linkColor
      ? `.sellwild-widget a.sellwild-main-link { color: ${theme.linkColor} }`
      : "",
    theme.linkSize
      ? `.sellwild-widget a.sellwild-main-link { font-size: ${theme.linkSize}px }`
      : "",
    theme.linkSize3
      ? `@media all and (max-width: 1200px) { .sellwild-widget a.sellwild-main-link { font-size: ${theme.linkSize3}px } }`
      : "",
    theme.linkSize2
      ? `@media all and (max-width: 900px) { .sellwild-widget a.sellwild-main-link { font-size: ${theme.linkSize2}px } }`
      : "",
    theme.linkSize1
      ? `@media all and (max-width: 600px) { .sellwild-widget a.sellwild-main-link { font-size: ${theme.linkSize1}px } }`
      : "",
    `.sellwild-banner, .sellwild-banner-bottom {display: flex;justify-content: center;align-items: center;height: 90px; max-width: 100%; overflow: hidden; margin-bottom: ${theme.marginBottom}px;}`,
    `.sellwild-banner-bottom {align-items: flex-start;}`,
    `.sellwild-zip-ad {position: relative; background-color: #eee; width: 300px; height: 250px; margin-bottom: ${theme.marginBottom}px; display: flex; justify-content: center; align-items: center; background-size: cover}`,
    `.sellwild-grid {display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-around;overflow: hidden;}`,
    `.sellwild-listing {position: relative;width: ${theme.cardWidth}; height: 250px; color: inherit; margin-bottom: 1em; text-decoration: none;display: block;overflow:hidden;}`,
    `.sellwild-listing-skinny{width: ${theme.skinnyWidth};}`,
    `.sellwild-listing-short{width: ${theme.shortWidth};height: ${theme.shortHeight};}`,
    `.sellwild-widget-overlay .sellwild-listing { margin-bottom: ${theme.marginBottom}px; }`,
    '.listing-img-container {width: 100%!important; height: 250px!important; background: #eee;}',
    `.listing-img {width: 100%!important; height: 250px!important; background: #eee; object-fit: cover; }`,
    `.sellwild-listing-short .listing-img { height: ${theme.shortHeight}!important; }`,
    `.listing-overlay {position: absolute;transition: visibility 0s linear 0.3s, opacity 0.3s ease-in;background-color: ${theme.colors[0]};opacity: 0;color: ${theme.fontColor};top: 0;bottom: 0;left: 0;right: 0;z-index: 1;}`,
    `.listing-price {position: absolute;bottom: 0;right: 0;color: ${
      theme.priceFontColor || theme.fontColor
    };line-height: 2em;padding: 0px 18px;background-color: ${
      theme.priceColor || theme.colors[0]
    };text-decoration: none;z-index: 3; font-size: ${theme.fontSize}px;}`,
    `.listing-title {margin: 6px 0; font-size: ${theme.fontSize}px;}`,
    `.sellwild-widget-overlay .listing-title {color: ${theme.fontColor}!important;position: absolute;visibility: hidden;text-align: center;text-decoration: none;opacity: 0;margin-top: 60px;left: 0;right: 0;top: 0;bottom: 0;left: 0;right: 0;z-index: 2;padding: 0 8px;transition: visibility 0s linear 0.3s, opacity 0.3s ease-in;}`,
    `.sellwild-listing-short .listing-title {margin-top: 20px;font-size: ${Math.floor(theme.fontSize*0.75)}px;}`,
    `.sellwild-widget-overlay a:hover .listing-overlay {opacity: 0.5;visibility: visible;transition: visibility 0s linear, opacity 0.3s ease-in;}`,
    `.sellwild-widget-overlay a:hover .listing-title {opacity: 1;visibility: visible;transition: visibility 0s linear, opacity 0.3s ease-in;}`,
    `.sellwild-banner-ad {background-color: #eee; width: 728px; max-width: 100%; height: 90px;}`,
    `.sellwild-listing-ad {background-color: #eee; width: 300px; height: 250px; margin-bottom: ${theme.marginBottom}px;}`,
    `.sellwild-listing-ad-skyscraper {width: 300px; margin-bottom: ${theme.marginBottom}px; display: flex; justify-content: center; align-items: center;}`,
    `.sellwild-watermark {display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-around;}`,
    `.sellwild-watermark div {width: 300px; display: flex; justify-content: flex-end;}`,
    `.sellwild-watermark svg {height: 34px;filter: grayscale(1);opacity: 0.5;transition: all 0.2s ease-in;}`,
    `.sellwild-watermark:hover svg {filter: grayscale(0);opacity: 1;}`,
    `.sellwild-popover {opacity: 0; visibility: hidden; position: absolute; transform: translate(0, 10px); right: 100px; background-color: #ffffff; padding: 1.5rem; box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26); width: auto!important; font-size: 14px;}`,
    `.sellwild-watermark:hover .sellwild-popover {z-index: 10; opacity: 1; visibility: visible; transform: translate(0, -20px); transition: all 0.5s cubic-bezier(0.75, -0.02, 0.2, 0.97);}`,
    `.sellwild-watermark .sellwild-popover a {color: ${theme.titleColor}!important;}`,
    theme.css,
  ].join(" ");
}


export function afterInteraction(fn: () => any) {
  document.addEventListener("mousemove", fn);
  document.addEventListener("touchstart", fn);
  return () => {
    document.removeEventListener("mousemove", fn);
    document.removeEventListener("touchstart", fn);
  };
}
